import { Component, ElementRef } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ToastController,
} from "ionic-angular";
import { Observable } from "../../../node_modules/rxjs";

import { EvaluationService } from "../../services/evaluation-service";
import { RealizeEvaluationService } from "../../services/realize-evaluation-service";

import { AppliedEvaluation } from "../../model/avalicorp/AppliedEvaluationModel";

import _ from "lodash";
import swal from "sweetalert2";
import { AppliedEvaluationStatus } from "../../services/applied-evaluation-status-constant";

@IonicPage()
@Component({
  selector: "page-realize-evaluation",
  templateUrl: "realize-evaluation.html",
})
export class RealizeEvaluationPage {
  public showRealize: boolean;
  public selectedType: string;
  public appliedEvaluation: AppliedEvaluation;
  public userId: number;
  public check: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public element: ElementRef,
    private evaluationService: EvaluationService,
    private service: RealizeEvaluationService
  ) {}

  ionViewDidLoad() {
    if (this.navParams.get("appliedEvaluation") != null) {
      this.appliedEvaluation = this.navParams.get("appliedEvaluation");
      this.userId = this.navParams.get("userId");
      this.getCompetenceAndQuestions();
    }
    this.showRealize = false;
    this.selectedType = "competences";
  }

  conclude() {
    if (!this.checkIsConcluded()) {
      swal(
        "Atenção",
        "Avaliação incompleta, selecione a resposta para todas as questões!",
        "warning"
      );
      return;
    }

    this.service
      .conclude(this.appliedEvaluation.id, this.userId)
      .subscribe(() => {
        this.presentToast("Salvo com sucesso");
        this.cancel();
      });
  }

  public checkIsConcluded() {
    return _.every(this.appliedEvaluation.evaluation.competencies, (item) => {
      return _.every(item.questions, "answerId");
    });
  }

  reprove() {
    this.showCommentReprove().then((result) => {
      if (result === undefined) return;
      this.appliedEvaluation.status = AppliedEvaluationStatus.REPROVADO;
      this.appliedEvaluation.usersProcess.supervisor.status =
        AppliedEvaluationStatus.AGUARDANDO_CONCLUSAO;
      this.appliedEvaluation.usersProcess.evaluator.status =
        AppliedEvaluationStatus.EM_ANDAMENTO;
      this.appliedEvaluation.usersProcess.evaluator.concludeDate = null;
      this.appliedEvaluation.usersProcess.evaluator.informedDisapproval = null;
      this.saveEvaluation();
    });
  }

  saveEvaluation() {
    this.evaluationService.save(this.appliedEvaluation).subscribe(() => {
      this.presentToast("Salvo com sucesso");
      this.cancel();
    });
  }

  saveResultQuestion(question) {
    var result = this.service.getResultToSave(
      question,
      this.appliedEvaluation,
      this.userId
    );
    this.service.saveResultQuestion(result).subscribe((data) => {
      question.resultId = data.id;
      this.presentToast("Salvo com sucesso");
    });
  }

  saveDiscursiveResultQuestion = (function () {
    var timer = 0;
    return function (question) {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        this.saveResultQuestion(question);
      }, 1000);
    };
  })();

  saveCommentEvaluated = (function () {
    var timer = 0;
    return function () {
      window.clearTimeout(timer);
      if (!this.appliedEvaluation.usersProcess.evaluated.comment) return;
      timer = window.setTimeout(() => {
        this.saveComment();
      }, 1000);
    };
  })();

  saveComment() {
    this.evaluationService.save(this.appliedEvaluation).subscribe(() => {
      this.presentToast("Salvo com sucesso");
    });
  }

  cancel() {
    this.navCtrl.pop();
  }

  private getCompetenceAndQuestions() {
    Observable.forkJoin(
      this.service.getQuestionsByCompetence(
        this.appliedEvaluation.id,
        this.userId
      ),
      this.service.findEvaluationQuestionsByAppliedIdAndUserId(
        this.appliedEvaluation.id,
        this.userId
      )
    ).subscribe((data) => {
      var competenceQuestions = data[0],
        discursiveQuestions = data[1];
      this.appliedEvaluation.editable = competenceQuestions[0].editable;
      this.appliedEvaluation.evaluation = _.assign(
        { name: competenceQuestions[0].evaluation },
        { competencies: competenceQuestions },
        { questions: discursiveQuestions }
      );
      this.setResults(this.appliedEvaluation);
    });
  }

  private setResults(applied) {
    var setCompetenceIndicators = this.setCompetenceIndicatorAndQuestions();
    applied.evaluation.competencies.forEach(setCompetenceIndicators);

    return this.service.listAllAnswers().subscribe((answers) => {
      this.service.getCompetenceQuestion(
        applied.evaluation,
        (competence, question) => {
          question.competenceId = parseInt(
            competence.id || competence.competenceId
          );
          question.answers = _.clone(answers);
        }
      );
      this.service.setDiscursiveQuestions(applied);
      this.check = this.service.getValidators(applied);
      this.showRealize = true;
    });
  }

  private setCompetenceIndicatorAndQuestions() {
    var indicatorsColor = {
      Superior: "secondary",
      Satisfatorio: "warning",
      Insatisfatorio: "danger",
    };
    return (competence) => {
      competence.questions = _.assign(
        [],
        JSON.parse(competence.competenceQuestions)
      );
      competence.indicator = _.assign({}, JSON.parse(competence.indicator));
      competence.indicator.color = indicatorsColor[competence.indicator.name];
    };
  }

  public showCommentReprove() {
    return swal({
      title: "Reprovar Avaliação!",
      text: "Motivo da reprovação?",
      input: "text",
      showCancelButton: true,
      showCloseButton: true,
      buttonsStyling: false,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Confirmar",
      type: "question",
    }).then((result) => {
      this.appliedEvaluation.usersProcess.supervisor.comment = result.value;
      return result.value;
    });
  }

  resizeTextArea(e) {
    let textArea =
      this.element.nativeElement.getElementsByTagName("textarea")[0];
    textArea.style.overflow = "hidden";
    textArea.style.height = "auto";
    textArea.style.height = textArea.scrollHeight + 32 + "px";
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 1000,
      position: "bottom",
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/avalicorp-realize-evaluation/realize-evaluation.ts